/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseKassensichvInfo
 */
export interface GetConfig200ResponseKassensichvInfo {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseKassensichvInfo
     */
    tseSerialNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof GetConfig200ResponseKassensichvInfo
     */
    tseActivationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseKassensichvInfo
     */
    tseCertificationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseKassensichvInfo
     */
    tseType: string;
    /**
     * 
     * @type {Date}
     * @memberof GetConfig200ResponseKassensichvInfo
     */
    locationCreationTime?: Date;
}

/**
 * Check if a given object implements the GetConfig200ResponseKassensichvInfo interface.
 */
export function instanceOfGetConfig200ResponseKassensichvInfo(value: object): value is GetConfig200ResponseKassensichvInfo {
    if (!('tseSerialNumber' in value) || value['tseSerialNumber'] === undefined) return false;
    if (!('tseActivationDate' in value) || value['tseActivationDate'] === undefined) return false;
    if (!('tseCertificationId' in value) || value['tseCertificationId'] === undefined) return false;
    if (!('tseType' in value) || value['tseType'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseKassensichvInfoFromJSON(json: any): GetConfig200ResponseKassensichvInfo {
    return GetConfig200ResponseKassensichvInfoFromJSONTyped(json, false);
}

export function GetConfig200ResponseKassensichvInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseKassensichvInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'tseSerialNumber': json['tseSerialNumber'],
        'tseActivationDate': (new Date(json['tseActivationDate'])),
        'tseCertificationId': json['tseCertificationId'],
        'tseType': json['tseType'],
        'locationCreationTime': json['locationCreationTime'] == null ? undefined : (new Date(json['locationCreationTime'])),
    };
}

export function GetConfig200ResponseKassensichvInfoToJSON(json: any): GetConfig200ResponseKassensichvInfo {
    return GetConfig200ResponseKassensichvInfoToJSONTyped(json, false);
}

export function GetConfig200ResponseKassensichvInfoToJSONTyped(value?: GetConfig200ResponseKassensichvInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tseSerialNumber': value['tseSerialNumber'],
        'tseActivationDate': ((value['tseActivationDate']).toISOString()),
        'tseCertificationId': value['tseCertificationId'],
        'tseType': value['tseType'],
        'locationCreationTime': value['locationCreationTime'] == null ? undefined : ((value['locationCreationTime']).toISOString()),
    };
}

